// TODO: SHARE IS LOVE NEEDS TO REDESIGNED, AS THINGS ARE REALLY DIFFERENT NOW 
import React, { useState,useContext } from 'react';
import AnnoucementTemplate from './index';
import { useHarvestingContext } from 'src/views/harvesting/harvesting-context'; 
import { AuthContext } from 'src/context/AuthContext';
import {
  Button,
  Typography,
  TextField
} from '@material-ui/core';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import {telegramMessage} from 'src/Api';
import { useAlertContext } from 'src/context/AlertContext';
import { v4 as uuid } from 'uuid';
import { doc, setDoc,serverTimestamp } from 'firebase/firestore'; 
import { useFirestore } from 'reactfire';

const ShareIsLoveDialog = ({ open,setOpen }) => {

  const [shareId, setShareId]= useState(null);
  const {user} = useContext(AuthContext);
  const link = shareId?window.location.origin+'/app/share-is-love?SID='+shareId:'';
  const {resetBaskets ,allFruits} = useHarvestingContext();
  const {useErrorAlert, useAlert} = useAlertContext();
  const [shareloading, setShareLoading] = useState(false);
  const db = useFirestore();
  const shareFishes = () => {
    setShareLoading(true);
    // alert("sharing");
    const id = uuid();

    setDoc(doc(db, 'shareFishes', id), {
      id:id,
      name:user.name,
      output:allFruits,
      createdAt: serverTimestamp(),
    })
      .then(() =>{
        setShareId(id);

        const replyLink = window.location.origin+'/app/share-is-love?SID='+id;
        const message =`
          *Share is love 🥰* %0A%0A[${user.name}](tg://user?id=${user.telegramId}) has created a share link with you, Please click the link below to recieve fishes 😃%0A %0A[${replyLink}](${replyLink})`;
        telegramMessage(user.telegramId,message)
          .then(()=>{
            useAlert('Shared fruit successfully','success');
            setShareLoading(false);
          })
          .catch(err=>{
            useErrorAlert('telegram send message error', err);
            setShareLoading(false);
          });

      });
  };
  const ShareIdBoard = () =>{
  
    return (
      <>
        <Typography variant="h5" gutterBottom>
                    Share Link is ready
        </Typography>
        <TextField label="Share Link" variant="outlined" value={link} size="small" />
        <CopyToClipboard
          text={link}
        >
          
          <Button
            disabled={shareloading}
            variant="contained" color="primary"
            style={{ minWidth: 'unset', padding: 13, marginLeft: 4 }}
          >
            <FileCopyIcon style={{ fontSize: 14 }} />
          </Button>
        </CopyToClipboard>
      </>
    );
  }; 

  if(!shareId){

 
    return (
      <div>
        <AnnoucementTemplate
          open={open}
          title="Share your fish list with others"
          description="The system will generate a link which store up all fishes you have right now, send the link to your friend, so that the fish list can be transferred to your friend"
          buttons={[
            {
              name: 'Share fishes now',
              isLoading:shareloading,
              color: 'primary',
              clickFunc: shareFishes,
              varient: 'contained',
            },
            {
              name: 'Back',
              clickFunc: ()=>setOpen(false),
              varient: 'outlined',
            },
            
          ]}
        />
      </div>
    );
  }
  else{
 
    return (
      <div>
        <AnnoucementTemplate
          open={open}
          title="Share your fish list with others"
          description={<ShareIdBoard/>}
          buttons={[
            
            {
              name: 'close',
              color: 'primary',
              clickFunc: ()=>{setOpen(false);setShareId(null);},
              varient: 'contained',
            },
            
          ]}
        />
      </div>
    );
  }
 
};
export default ShareIsLoveDialog;